import { BASE_URL, INDIAN_MSME_USER_TOKEN } from "../../utils/Constants";
import { RootState } from "..";
import axios from "axios";
import { ThunkAction } from "redux-thunk";
import ProfileType, {
  Notifications,
  UpdateBankDetails,
  UpdateKYC,
  UpdateProfile,
  UpdateTermsConditions,
  userType,
  ChangePassword,
  ChangeProductViewStatus,
  GetCity,
} from "../types/profileType";
import { toast } from "react-toastify";
import { getCookie } from "../../utils/CookieAction";
import LogoutAction from "./LogoutAction";
import { log } from "console";
import OrderType, { GetOrder } from "../types/OrderType";

interface Action {
  type: string;
  payload?: any;
  message?: string;
}

const ProfileAction = {
  getProfile:
    (): ThunkAction<void, RootState, null, Action> => async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const profileData: any = await axios.get(BASE_URL + "account/profile", {
          headers: {
            Authorization: "Bearer " + JSON.parse(token),
            Accept: "application/json",
          },
        });

        dispatch({
          type: ProfileType.SET_PROFILE_DETAILS,
          payload: profileData.data.data,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  updateProfile:
    (data: UpdateProfile): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      console.log(data);
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);

        const kycDoc: any = await axios.post(
          BASE_URL + "account/update",
          {
            name_of_entity: data.name,
            rep_name: data.repName,
            mobile: data.mobile,
            state: data.state,
            district: data.district,
            pin_code: data.pincode,
            address: data.address,
            gst_no: data.gstNo,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
            },
          },
        );

        if (kycDoc.data.status) {
          dispatch({
            type: ProfileType.UPDATE_KYC_DOCUMENTS,
          });
          toast.success(kycDoc.data.msg);
        } else {
          toast.error(kycDoc.data.msg);
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
        toast.error(error.response.data.msg);
      }
    },

  updateKYC:
    (data: UpdateKYC): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);

        const result: any = await axios.post(
          BASE_URL + "account/kyc",
          {
            gst_no: data.gst,
            pan_no: data.pan,
            aadhaar_card_number: data.aadhaar,
            gst_image: data.gstImage,
            pan_card_image: data.panImage,
            aadhaar_card_front: data.aadhaarFront,
            aadhaar_card_back: data.aadhaarBack,
            daf: data.daf,
            cheque: data.cheque,
            profile_image: data.profile,
            company_image: data.company,
            signature_image: data.signature,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              "Content-Type": "multipart/form-data",
            },
          },
        );

        console.log(result);

        if (result.data.status) {
          dispatch({
            type: ProfileType.UPDATE_PROFILE,
          });
          toast.success(result.data.msg);
        } else {
          toast.error(result.data.msg);
        }
      } catch (error: any) {
        console.log(error);

        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
        toast.error(error.response.data.msg);
      }
    },

  updateBankDetails:
    (data: UpdateBankDetails): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);

        const result: any = await axios.post(
          BASE_URL + "account/bank",
          {
            bank_name: data.bankName,
            bank_account: data.bankAccount,
            branch_name: data.bankBranch,
            ifsc_code: data.ifscCode,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
            },
          },
        );

        if (result.data.status) {
          dispatch({
            type: ProfileType.UPDATE_BANK_DETAILS,
          });
          toast.success(result.data.msg);
        } else {
          toast.error(result.data.msg);
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
        toast.error(error.response.data.msg);
      }
    },
  becomeASeller:
    (): ThunkAction<void, RootState, null, Action> => async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "account/become_a_seller",
          {},
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          },
        );

        if (result.data.status) {
          dispatch({
            type: ProfileType.BECOME_A_SELLER,
          });
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
  getDashboardData:
    (): ThunkAction<void, RootState, null, Action> => async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.get(BASE_URL + "dashboardData", {
          headers: {
            Authorization: "Bearer " + JSON.parse(token),
            Accept: "application/json",
          },
        });

        if (result.data.status) {
          dispatch({
            type: ProfileType.DASHBOARD_DATA,
            payload: result.data.data,
          });
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
  changeUserType:
    (data: userType): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        dispatch({
          type: ProfileType.SET_USER_TYPE,
          payload: data.type,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
  getNotifications:
    (data: Notifications): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "notifications",
          {
            search: data.search,
            limit: data.limit,
            page: data.page,
            type: data.type,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          },
        );

        dispatch({
          type: ProfileType.SET_NOTIFICATIONS,
          payload: {
            data: result.data.data.data,
            currentPage: result.data.data.current_page,
            lastPage: result.data.data.last_page,
            totalData: result.data.data.total,
            from: result.data.data.from,
            to: result.data.data.to,
            type: data.type,
          },
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
  updateTermsConditions:
    (data: UpdateTermsConditions): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);

        const result: any = await axios.post(
          BASE_URL + "account/term-conditions",
          {
            terms_conditions: data.terms_conditions,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
            },
          },
        );

        if (result.data.status) {
          dispatch({
            type: ProfileType.UPDATE_BANK_DETAILS,
          });
          toast.success(result.data.msg);
        } else {
          toast.error(result.data.msg);
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
        toast.error(error.response.data.msg);
      }
    },

  getState:
    (): ThunkAction<void, RootState, null, Action> => async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.get(BASE_URL + "account/state", {
          headers: {
            Authorization: "Bearer " + JSON.parse(token),
            Accept: "application/json",
          },
        });

        if (result.data.status) {
          dispatch({
            type: ProfileType.SET_STATE_DATA,
            payload: result.data.data,
          });
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  changePassword:
    (data: ChangePassword): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);

        const result: any = await axios.post(
          BASE_URL + "account/change-password",
          {
            old_password: data.old_password,
            new_password: data.new_password,
            confirm_password: data.confirm_password,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
            },
          },
        );

        if (result.data.status) {
          dispatch({
            type: ProfileType.CHANGE_PASSWORD,
          });
          toast.success(result.data.msg);
        } else {
          toast.error(result.data.msg);
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
        toast.error(error.response.data.msg);
      }
    },

  changeProductViewStatus:
    (
      data: ChangeProductViewStatus,
    ): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);

        const result: any = await axios.post(
          BASE_URL + "account/change-product-view-status",
          {
            id: data.id,
            product_view_status: data.product_view_status,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
            },
          },
        );
        if (result.data.status) {
          dispatch({
            type: ProfileType.CHANGE_PRODUCT_VIEW_STATUS,
          });
          toast.success(result.data.msg);
        } else {
          toast.error(result.data.msg);
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
        toast.error(error.response.data.msg);
      }
    },

  getCity:
    (data: GetCity): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);

        const result: any = await axios.post(
          BASE_URL + "account/city",
          {
            state_id: data.state_id,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
            },
          },
        );
        if (result.data.status) {
          dispatch({
            type: ProfileType.SET_CITY_LIST,
            payload: result.data.data,
          });
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getAllCity:
    (): ThunkAction<void, RootState, null, Action> => async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.get(BASE_URL + "account/all-city", {
          headers: {
            Authorization: "Bearer " + JSON.parse(token),
            Accept: "application/json",
          },
        });

        if (result.data.status) {
          dispatch({
            type: ProfileType.SET_ALL_CITY_LIST,
            payload: result.data.data,
          });
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getErmData:
    (): ThunkAction<void, RootState, null, Action> => async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const ermData: any = await axios.get(
          BASE_URL + "account/erm-card-details",
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          },
        );

        dispatch({
          type: ProfileType.SET_ERM_DETAILS,
          payload: ermData.data.data,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
  getLatestMessage:
    (): ThunkAction<void, RootState, null, Action> => async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.get(BASE_URL + "latest-message/BUYER", {
          headers: {
            Authorization: "Bearer " + JSON.parse(token),
            Accept: "application/json",
          },
        });

        if (result.data.status) {
          dispatch({
            type: ProfileType.GET_LATEST_MESSAGE,
            payload: result.data.data,
          });
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
};

export default ProfileAction;
